





























































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FeriadoStore from '@/components/RemuneracaoMedica/financeiro/Store/FeriadoStore'
import EventBus from '@/plugins/EventBus'
import { formatDateOnly, timeout } from '@/utils/common'
import { ItemFeriado } from '@/types/interfaces/FinanceiroTypes'

@Component
export default class ViewFinanceiroTabelaFeriados extends Vue {
  itemFeriadoMode: string = 'CREATE'

  loadEditarFeriado: string = ''
  get loadingEditarFeriado() { return this.loadEditarFeriado }
  set loadingEditarFeriado(value: string) { this.loadEditarFeriado = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteFeriado: boolean = false
  get loadingDeleteFeriado() { return this.loadDeleteFeriado }
  set loadingDeleteFeriado(value: boolean) { this.loadDeleteFeriado = value }

  get itemToDeleteId() { return this.feriadoStore.itemToDeleteId }
  set itemToDeleteId(value: string) { this.feriadoStore.setItemToDeleteId(value) }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  get feriadoStore() {
    return getModule(FeriadoStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Nome', value: 'nome', align: 'left', sortable: false },
      { text: 'Data', value: 'data', align: 'left', sortable: false },
      { text: 'Tipo', value: 'tipo', align: 'left', sortable: false },
      { text: 'Observação', value: 'observacao', align: 'center', sortable: false },
      { text: 'Criado por', value: 'criadoEm', align: 'center', sortable: false },
      { text: 'Criado em', value: 'criadoPor', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsFeriados() {
    return this.feriadoStore.feriadoList
  }

  formateDate(date: any) {
    return formatDateOnly(date)
  }

  criarItemFeriado() {
    this.itemFeriadoMode = 'CREATE'
    this.feriadoStore.clearItemFeriado()
    this.feriadoStore.setModal({ name: 'itemFeriado', value: true })
  }

  async editarFeriado(item: any) {
    this.itemFeriadoMode = 'EDIT'
    this.feriadoStore.clearItemFeriado()
    this.loadingEditarFeriado = item.id
    await timeout(500)
    this.feriadoStore.setOriginalItemFeriado({ ...item } as ItemFeriado)
    this.feriadoStore.setItemFeriado({ ...item } as ItemFeriado)
    this.feriadoStore.setModal({ name: 'itemFeriado', value: true })
    this.loadingEditarFeriado = ''
  }

  async apagarItemFeriado() {
    this.loadingDeleteFeriado = true
    const response = await this.feriadoStore.deleteItemFeriado()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeleteFeriado = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.feriadoStore.getAllItemsFeriado()
    this.loadingDataTable = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.feriadoStore.clearFeriadoList()
    this.feriadoStore.clearItemFeriado()
    await this.getAllItems()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.feriadoStore.total / this.feriadoStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.feriadoStore.pagina
  }

  set getPagina(value: number) {
    this.feriadoStore.setFeriadoListPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.feriadoStore.getAllItemsFeriado()
    this.loadingDataTable = false
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  @Watch('showModalDeleteItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) this.itemToDeleteId = ''
  }
}
